import Axios from 'axios';
import { unref } from 'vue';
/**
 *
 * @param {maybeRef} lang
 * @param {maybeRef} aanbod
 * @returns aanbodDefinitie
 */
async function getAanbodDefinitie(lang, aanbod) {
  const langValue = unref(lang);
  const aanbodValue = unref(aanbod);
  if (langValue === undefined || aanbodValue === undefined) {
    return {};
  }
  const response = await Axios.get(
    `${process.env.VUE_APP_API_ENDPOINT}/api/v1/aanbodDefinitie/${aanbodValue}?lang=${langValue}`
  );

  return response.data;
}

/**
 *
 * @param {maybeRef} aanbodVersionId
 * @param {maybeRef} subflowVersionIds
 * @param {maybeRef } taal
 * @returns aanbodDefinitie
 */
async function getAanbodDefinitieByVersion(aanbodVersionId, subflowVersionIds, taal) {
  const aanbodVersionIdValue = unref(aanbodVersionId);
  const subflowVersionIdsValue = unref(subflowVersionIds);
  const taalValue = unref(taal);
  if (aanbodVersionIdValue === undefined || subflowVersionIdsValue === undefined) {
    return {};
  }
  const response = await Axios.get(
    `${
      process.env.VUE_APP_API_ENDPOINT
    }/api/v1/aanbodDefinitie/aanbodByVersion/${aanbodVersionIdValue}?subflowVersionIds=${subflowVersionIdsValue.join()}&taal=${taalValue}`
  );

  return response.data;
}
export default {
  getAanbodDefinitie,
  getAanbodDefinitieByVersion
};
